var ResolveErrorModule = (function () {
    function ResolveErrorModule() {
    }
    return ResolveErrorModule;
}());
export { ResolveErrorModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/resolve-error/resolve-error.module.ts.pre-build-optimizer.js